/**
 * Makes sure the top banner get the right sticky position.
 *
 * @param {Number} baseOffset
 * @returns {void}
 */
 export function stickyBanner(baseOffset = 0) {
  let offset = baseOffset;
  let banner = false;

  const menubar = document.getElementsByClassName('c-menu__main');
  const affiliateBanner = document.querySelectorAll('.native-sponsored-splash:not(.initialized)')[0];
  const nativeBanner = document.querySelectorAll('.c-native_banner:not(.initialized)')[0];

  // Set which banner to update
  banner = (affiliateBanner) ? affiliateBanner : nativeBanner;

  if (menubar.length > 0 && banner) {
    const searchButton = document.querySelector('.c-menu__mobile__search--button');

    // Set offset on scroll
    window.addEventListener('scroll', () => {
      updateOffset(banner, offset);
    });

    // Set offset on show and hide search
    if (searchButton) {
      searchButton.addEventListener('click', () => {
        updateOffset(banner, offset);
      });
    }
  }
}

/**
 * Update top offset for banner
 * 
 * @param {object} banner 
 * @param {number} offset 
 */
function updateOffset(banner, offset) {
  // Timeout to wait for menu transitions so heights will be corrent
  setTimeout(function () {
    const menu = document.querySelector('.c-menu');
    let menuHeight = menu.offsetHeight;
    
    // Get all extra menu stuff
    const scrollMenu = document.querySelector('.c-menu__scroll');
    const isScrolled = menu.classList.contains('scrolled');

    // Add height for scroll menu if used
    if (scrollMenu && !isScrolled) {
        menuHeight += scrollMenu.offsetHeight;
    }
    offset = !(document.querySelector('.nav-hide')) ? menuHeight : 0;
    banner.style.top = `${offset}px`;

    // Set initialized class to avoid initializing it again
    banner.classList.add('initialized');
  }, 200);
}
